import React from 'react';
import PropTypes from 'prop-types';
import './Topic.scss';

// Skapa action list
import '@ingka/action-list/style.scss';
import '@ingka/focus/style.scss';
import '@ingka/switch/style.scss';
import '@ingka/svg-icon/style.scss';
import '@ingka/aspect-ratio-image/style.scss';
import '@ingka/button/style.scss';
import '@ingka/forms/style.scss';
import ActionList, { ActionListItem } from '@ingka/action-list';

const Topic = ({ label, caption, clickHandler, id }) => (
    <ActionList className="item-wrap" id={id}>
        <ActionListItem
            control="navigational"
            onClick={clickHandler}
            label={label}
            caption={caption}
            className="topic__item"
        />
    </ActionList>
);

Topic.propTypes = {
    label: PropTypes.string,
    caption: PropTypes.string,
    clickHandler: PropTypes.func,
    id: PropTypes.string,
};

export default Topic;
